import React from 'react';
import { useTranslation } from '@/modules/shared/i18n/useTranslation';
import { snakeToTitleCase } from '@/modules/shared/utils';
import type { GlobalSearchHit } from '../types';
import { en, th } from '../locales';
import AgentCard from './AgentCard';
import ResultCard from './ResultCard';

const ResultGroup: React.FC<{ documentType: string; hits: GlobalSearchHit[]; onNavigated: () => void }> = ({
  documentType,
  hits,
  onNavigated,
}) => {
  const { t } = useTranslation({ en, th });
  const heading = documentType === 'qoala_sub_order' ? t('platformOrders') : snakeToTitleCase(documentType);
  const CardComponent = documentType === 'affiliate' ? AgentCard : ResultCard;

  return (
    <section data-testid={`global-search-group-${documentType}`}>
      <h3 className="mb-2 text-sm font-semibold text-foreground">{heading}</h3>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {hits.map((hit) => (
          <CardComponent key={hit.id} hit={hit} onNavigated={onNavigated} />
        ))}
      </div>
    </section>
  );
};

export default ResultGroup;
